type Meta = {
  alias: string;
  name: string;
};

export const meta: Meta = {
  alias: 'popup',
  name: 'Popup'
};
